import http from '../http-common'

export default class GeneralServices {
    async getTermsOfUserFinished() {
        return http.get("v1/general/terms-of-user-finished");
    }
}